<template>
	<MultiLink
		:link="blok.link"
		:aria-label="blok.largeImage.alt || blok.smallImage.alt || 'Zjistit více'"
		class="relative block w-full rounded-lg overflow-hidden shadow-green-sm aspect-square md:aspect-[41/10] focus-outline"
	>
		<NuxtImg
			provider="storyblok"
			:src="blok.largeImage.filename"
			:alt="blok.largeImage.alt || ''"
			sizes="md:30vw lg:30vw xl:30vw"
			class="w-full h-full object-cover cover-parent max-md:hidden"
		/>
		<NuxtImg
			provider="storyblok"
			:src="blok.smallImage.filename"
			:alt="blok.smallImage.alt || ''"
			sizes="min:30vw xs:30vw sm:30vw"
			class="w-full h-full object-cover cover-parent md:hidden"
		/>
	</MultiLink>
</template>

<script setup lang="ts">
	import type {HomepageIntroSecondaryItemStoryblok} from '~/storyblok/types';
	import MultiLink from '~/components/MultiLink.vue';

	type Props = {
		blok: HomepageIntroSecondaryItemStoryblok
	};

	defineProps<Props>();
</script>
